import {GenerateInputs} from "../GenericInputField";
import Typography from "@material-ui/core/Typography";
import React, {useCallback, useEffect, useRef} from "react";
import {useTranslation} from "react-i18next";
import {ValidatorForm} from "react-form-validator-core";
import {apiPut} from "../../api";
import snackbar from "../../snackbar";

function DownloadDocument(props) {
    const {t, i18n} = useTranslation();
    let inputs = GenerateInputs({
        sign_different: {
            defaultValue: "",
            label: false,
            selection: [{
                key: "yes",
                label: t("dialog_download_document_checkbox"),
            }, {
                key: "no",
                label: t("dialog_download_document_checkbox2"),
            }],
            type: 'radio'
        },
        comment: {
            defaultValue: '',
            label: t("dialog_plh_confirm"),
            type: "textarea"
        }
    });
    let inputRef = useRef(null);
    let submit = useCallback(() => {
        props.dialog.send(inputs.sign_different.value, inputs.comment.value);
    }, [inputs.sign_different.value, inputs.comment.value]);
    props.dialog.getData = () => [inputs.sign_different.value, inputs.comment.value];

    useEffect(() => {
        props.dialog.setState({
            okDisabled: !inputs.sign_different.value,
        });
    }, [inputs.sign_different.value]);

    return <ValidatorForm ref={inputRef} onSubmit={submit} noValidate autoComplete="off">
        <div>
            <Typography variant={"body1"}>{t("dialog_download_document_help")}</Typography>
            <div>
                {inputs.sign_different.field}
            </div>
            {inputs.sign_different.value === "yes" ? <div>
                {inputs.comment.field}
            </div> : null}
        </div>
    </ValidatorForm>;
}

export default DownloadDocument;